import React, { useState, useRef, useEffect } from 'react';
import { useAddressApiGouv } from '@/hooks/useAddressApiGouv';
import { Input } from './UI/Input';

interface AddressAutocompleteProps {
  value: string;
  onChange: (value: string, validated: boolean, inseeCode?: string) => void;
  error?: string;
}

export const AddressAutocomplete: React.FC<AddressAutocompleteProps> = ({
  value,
  onChange,
  error,
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { suggestions, searchAddress, clearSuggestions } = useAddressApiGouv();
  const containerRef = useRef<HTMLDivElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue, false);
    searchAddress(newValue);
    setShowSuggestions(true);
  };

  const handleSelectAddress = (address: string, inseeCode?: string) => {
    onChange(address, true, inseeCode);
    setShowSuggestions(false);
    clearSuggestions();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} className="relative">
      <Input
        label="Adresse du bien *"
        value={value}
        onChange={handleInputChange}
        placeholder="Saisissez l'adresse"
        autoComplete="off"
        error={error}
      />
      {showSuggestions && suggestions.filter(s => s.type !== 'commune').length > 0 && (
        <div className="absolute top-full left-0 right-0 bg-white border border-border mt-1 max-h-60 overflow-y-auto z-[100] rounded-md shadow-lg">
          {suggestions.filter(s => s.type !== 'commune').map((suggestion, index) => (
            <div
              key={index}
              className="p-4 cursor-pointer transition-colors border-b border-[#F5F5F5] text-sm hover:bg-[#FAFAFA] last:border-b-0"
              onClick={() => handleSelectAddress(suggestion.description, suggestion.inseeCode)}
            >
              <div className="flex items-start gap-2">
                <span className="inline-block px-2 py-0.5 rounded text-xs bg-purple-100 text-purple-700">
                  Adresse
                </span>
                <span className="flex-1">{suggestion.description}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
